import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';

export enum TriCheckState {
  None,
  Mixed,
  All
}

export class InputTriCheck extends LitElement {
  @property() checked = TriCheckState.None;
  @property() readonly = false;
  @property() disabled = false;
  @property() label = '';

  render() {
    const clickEvent = (e: Event) => {
      e.stopPropagation();
      e.preventDefault();
      if (this.readonly || this.disabled) return;
      this.checked = this.checked !== TriCheckState.All ? TriCheckState.All : TriCheckState.None;
      this.click();
    };
    // Use webmodule-icon (not a raw FontAwesome <i>) so the check glyph renders when
    // this control is placed inside a shadow-DOM host such as <webmodule-table>, where
    // the global FontAwesome CSS cannot reach.
    const color = this.disabled || !this.checked ? 'gray' : 'primary';
    const checkIcon = () => {
      switch (this.checked) {
        case TriCheckState.None:
          return html`<webmodule-icon library="fa" name="far-square" color=${color}></webmodule-icon>`;
        case TriCheckState.Mixed:
          return html`<webmodule-icon library="fa" name="far-square-check" color=${color}></webmodule-icon>`;
        case TriCheckState.All:
          return html`<webmodule-icon library="fa" name="fas-square-check" color=${color}></webmodule-icon>`;
      }
    };
    return html`<span @click=${clickEvent}> ${checkIcon()} ${this.label} </span>`;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }
}
